import { render, staticRenderFns } from "./zt-driver-adas-alarm-modal.vue?vue&type=template&id=387292b4"
import script from "./zt-driver-adas-alarm-modal.vue?vue&type=script&lang=js"
export * from "./zt-driver-adas-alarm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports